<template>
  <div class="vue-terminal" @click="handleFocus">
    <div class="terminal-header" v-if="showHeader">
      <h4>{{ title }}</h4>
      <ul class="shell-dots">
        <li class="shell-dots-red"></li>
        <li class="shell-dots-yellow"></li>
        <li class="shell-dots-green"></li>
      </ul>
    </div>

    <div>
      <span class="btn-clear" @click="clearTerm"> clear </span>
      <div class="terminal-window" ref="terminalWindow">
        <p v-if="greeting">{{ greeting }}</p>
        <p v-if="defaultTaskCommandd">
          <span class="prompt"></span>
          <span class="cmd">{{ defaultTaskCommandd }}</span>
        </p>

        <p v-for="(item, index) in messageList" :key="index">
          <!-- <span>{{ item.time }}</span> -->
          <!-- <span v-if="item.label" :class="item.type">{{ item.label }}</span> -->
          <span v-if="item.time" :class="item.type">{{ item.time }}</span>
          <span v-if="!item.message.list">
            <pre class="cmd" v-if="!item.message.list">{{ item.message }}</pre>
          </span>
          <span class="cmd" v-else>
            <pre>{{ item.message.text }}</pre>
            <ul>
              <li v-for="(li, index) in item.message.list" :key="index">
                <span v-if="li.label" :class="li.type">{{ li.label }}:</span>
                <pre>{{ li.message }}</pre>
              </li>
            </ul>
          </span>
        </p>

        <p v-if="actionResult">
          <span class="cmd">{{ actionResult }}</span>
        </p>

        <p class="terminal-last-line" ref="terminalLastLine">
          <!--
          <span v-if="lastLineContent==='&nbsp'">
            <span v-if="typeof prompt !== 'undefined'" class="prompt">{{prompt}}</span>
            <span class="prompt" v-else>\{{title}}</span>
          </span>
          <span>{{inputCommand}}</span>
          <span :class="lastLineClass" v-html="lastLineContent"></span>
          <input
            v-model="inputCommand"
            :disabled="lastLineContent!=='&nbsp'"
            autofocus="true"
            type="text"
            @keyup="handleCommand($event)"
            ref="inputBox"
            class="input-box"
          />
          -->
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "VueTerminal",
  data() {
    return {
      messageList: [],
      actionResult: "",
      lastLineContent: "...",
      inputCommand: "",
      supportingCommandList: "",
      historyIndex: 0,
      commandHistory: [],
    };
  },
  props: {
    commandList: {
      required: false,
      default: () => ({}),
    },
    taskList: {
      required: false,
      default: () => ({}),
    },
    title: {
      required: false,
      type: String,
      default: "vTerminal",
    },
    showHeader: {
      required: false,
      type: Boolean,
      default: true,
    },
    greeting: {
      required: false,
      type: String,
      default: undefined,
    },
    defaultTaskCommandd: {
      required: false,
      type: String,
      default: "",
    },
    defaultTask: {
      required: false,
      type: String,
      default: undefined,
    },
    prompt: {
      required: false,
      default: undefined,
    },
    showHelpMessage: {
      required: false,
      default: true,
    },
    unknownCommandMessage: {
      required: false,
      default: undefined,
    },
  },
  computed: {
    lastLineClass() {
      if (this.lastLineContent === "&nbsp") {
        return "cursor";
      } else if (this.lastLineContent === "...") {
        return "loading";
      }
    },
  },
  created() {
    this.supportingCommandList = Object.keys(this.commandList).concat(
      Object.keys(this.taskList)
    );
  },
  async mounted() {
    if (this.defaultTask) {
      // await this.handleRun(this.defaultTask);
    }

    this.lastLineContent = "&nbsp";
    //this.handleFocus();
  },
  methods: {
    handleFocus() {
      //this.$refs.inputBox.focus();
    },
    handleCommand(e) {
      if (e.keyCode !== 13) {
        this.handlekeyEvent(e);
        return;
      }
      this.commandHistory.push(this.inputCommand);
      this.historyIndex = this.commandHistory.length;
      if (typeof this.prompt !== "undefined") {
        this.pushToList({ message: `${this.prompt} ${this.inputCommand} ` });
      } else {
        this.pushToList({ message: `$ \\${this.title} ${this.inputCommand} ` });
      }
      if (!this.inputCommand) return;
      const commandArr = this.inputCommand.split(" ");
      if (this.commandList[this.inputCommand]) {
        this.commandList[this.inputCommand].messages.map((item) =>
          this.pushToList(item)
        );
      } else if (this.taskList[this.inputCommand.split(" ")[0]]) {
        this.handleRun(this.inputCommand.split(" ")[0], this.inputCommand);
      } else {
        if (this.unknownCommandMessage) {
          this.pushToList(this.unknownCommandMessage);
        } else {
          this.pushToList({ level: "System", message: "Unknown Command." });
          this.pushToList({
            level: "System",
            message: 'type "help" to get a supporting command list.',
          });
        }
      }
      this.inputCommand = "";
      this.autoScroll();
    },
    handlekeyEvent(e) {
      switch (e.keyCode) {
        case 38:
          this.historyIndex =
            this.historyIndex === 0 ? 0 : this.historyIndex - 1;
          this.inputCommand = this.commandHistory[this.historyIndex];
          break;
        case 40:
          this.historyIndex =
            this.historyIndex === this.commandHistory.length
              ? this.commandHistory.length
              : this.historyIndex + 1;
          this.inputCommand = this.commandHistory[this.historyIndex];
          break;
        default:
          break;
      }
    },
    handleRun(taskName, input) {
      if (!this.taskList[taskName] || !this.taskList[taskName][taskName])
        return Promise.resolve();
      this.lastLineContent = "...";
      return this.taskList[taskName][taskName](this.pushToList, input)
        .then((done) => {
          this.pushToList(done);
          this.lastLineContent = "&nbsp";
        })
        .catch((error) => {
          this.pushToList(
            error || {
              type: "error",
              label: "Error",
              message: "Something went wrong!",
            }
          );
          this.lastLineContent = "&nbsp";
        });
    },
    pushToList(message) {
      this.messageList.push(message);
      if (this.messageList.length > 1000) {
        this.messageList.shift();
      }
      this.autoScroll();
    },
    clearTerm() {
      this.messageList = [];

      this.autoScroll();
    },

    time() {
      return new Date().toLocaleTimeString().split("").splice(2).join("");
    },
    autoScroll() {
      this.$nextTick(() => {
        this.$refs.terminalWindow.scrollTop =
          this.$refs.terminalLastLine.offsetTop;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.vue-terminal .terminal-window {
  overflow-y: auto;
  scrollbar-color: rgba(93, 132, 144, 0.5) rgba(212, 224, 227, 0.67);
  scrollbar-width: thin;
  scrollbar-height: thin;
}

.vue-terminal .terminal-window::-webkit-scrollbar {
  width: 5px;
}

.vue-terminal .terminal-window::-webkit-scrollbar-track {
  background-color: rgba(212, 224, 227, 0.67);
  border-radius: 10px;
}

.vue-terminal .terminal-window::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: rgba(93, 132, 144, 0.5);
}

.vue-terminal {
  position: relative;
  width: 100%;
}
.vue-terminal .terminal-window {
  position: relative;
  overflow: auto;
  z-index: 1;
  background-color: #e4e7e7;
  min-height: 140px;
  max-height: 270px;
  padding: 20px;
  padding-top: 0px;
  font-weight: normal;
  font-family: Monaco, Menlo, Consolas, monospace;
  color: #656565;
  pre {
    font-family: Monaco, Menlo, Consolas, monospace;
    white-space: pre-wrap;
  }
  p {
    overflow-wrap: break-word;
    word-break: break-all;
    font-size: 14px;
    .cmd {
      line-height: 24px;
    }
    .info {
      padding: 2px 5px;
      background: #7098a6;
      border-radius: 4px;
      color: #fff;
    }
    .warning {
      padding: 2px 5px;
      border-radius: 4px;
      background: #ecd1a6; // https://github.com/Mayccoll/Gogh/blob/master/content/themes.md #Flat
    }
    .success {
      padding: 2px 5px;
      border-radius: 4px;
      background: #a4ceb6;
    }
    .error {
      padding: 2px 5px;
      border-radius: 4px;
      background: #dbbbb8;
    }
    .system {
      padding: 2px 5px;
      border-radius: 4px;
      background: #bdc3c7;
    }
  }
  pre {
    display: inline;
  }
}
.terminal-header ul.shell-dots li {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  margin-left: 6px;
}
.terminal-header ul .shell-dots-red {
  background-color: rgb(200, 48, 48);
}
.terminal-header ul .shell-dots-yellow {
  background-color: rgb(247, 219, 96);
}
.terminal-header ul .shell-dots-green {
  background-color: rgb(46, 201, 113);
}
.terminal-header {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  left: 0;
  background-color: rgb(149, 149, 152);
  text-align: center;
  padding: 2px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.terminal-header h4 {
  font-size: 14px;
  margin: 5px;
  letter-spacing: 1px;
}
.terminal-header ul.shell-dots {
  position: absolute;
  top: 5px;
  left: 8px;
  padding-left: 0;
  margin: 0;
}
.vue-terminal .terminal-window .prompt::before {
  content: "$";
  margin-right: 10px;
}
.vue-terminal .terminal-window .cursor {
  margin: 0;
  background-color: white;
  animation: blink 1s step-end infinite;
  -webkit-animation: blink 1s step-end infinite;
  margin-left: -5px;
}
@keyframes blink {
  50% {
    visibility: hidden;
  }
}
@-webkit-keyframes blink {
  50% {
    visibility: hidden;
  }
}
.vue-terminal .terminal-window .loading {
  display: inline-block;
  width: 0;
  overflow: hidden;
  overflow-wrap: normal;
  animation: load 1.2s step-end infinite;
  -webkit-animation: load 1.2s step-end infinite;
}
@keyframes load {
  0% {
    width: 0px;
  }
  20% {
    width: 5px;
  }
  40% {
    width: 10px;
  }
  60% {
    width: 15px;
  }
  80% {
    width: 20px;
  }
}
@-webkit-keyframes load {
  0% {
    width: 0px;
  }
  20% {
    width: 5px;
  }
  40% {
    width: 10px;
  }
  60% {
    width: 15px;
  }
  80% {
    width: 20px;
  }
}
.terminal-last-line {
  font-size: 0;
  word-spacing: 0;
  letter-spacing: 0;
}
.input-box {
  position: relative;
  background: rgb(3, 9, 36);
  border: none;
  width: 1px;
  opacity: 0;
  cursor: default;
}
.input-box:focus {
  outline: none;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/internal/Terminal.vue